export const DEBOUNCE_TIMEOUT = 500; //milliseconds
export const COLOR_TAB_MATERIAL_RIPPLE_COLOR = 'rgb(56, 142, 60, .25)';
